<template>
    <el-row>
        <el-row v-if="button" class="text-right">
            <yl-lc-button name="新增" :dataSource='dataSource1' type="primary" @click.native='add'></yl-lc-button>
        </el-row>
        <div v-for="(item,index) in list" :key="index">
            <el-row type="flex" :align="align">
                <el-col :span="button ? 22 : 24">
                    <slot :row="item" :$index="index"></slot>
                </el-col>
                <el-col :span="2" v-if="button">
                    <yl-lc-button name="删除" :dataSource='dataSource2' type="text" @click.native='del(index)'></yl-lc-button>
                </el-col>
            </el-row>
        </div>
    </el-row>
</template>
<script>
export default {
    name:"yl-lc-array-object",
    components: {
    },
    props: {
        button:{
            type:Boolean,
            default:true
        },
        group:{
            type:Array,
            default:[]
        },
        align:{
            type:String,
            default:"middle"
        },
    },
    watch: {
        "group":{
            handler(list){
                this.list = list;
            },
            immediate:true
        }
    },
    data() {
        return {
            list:null,
            index:null,
            dataSource1:{
                isHtml: false,
                body:"新增"
            },
            dataSource2: {
                isHtml: false,
                body:"删除"
            }
        }
    },
    mounted() {
        
    },
    methods: {
        add(){
            this.list.push({});
        },
        del(index){
            index = (index || index==0) ? index : this.index;
            if(index || index ==0){
                this.list.splice(this.index,1);
            }else{
                this.$message.warning('请选择要删除的数据');
            }
        }
    }
}
</script>
<style lang="less" scoped>

</style>